<script lang="ts" setup>
import { WalletConnectStatus } from '@shared/types'
import { Modal, MixPanelConnectEntryPoint } from '@/types'

const modalStore = useSharedModalStore()
const sharedWalletStore = useSharedWalletStore()
const { $onError } = useNuxtApp()

function onWalletConnect() {
  import('@/app/providers/mixpanel/EventTracker')
    .then(({ trackWalletConnectInitiated }) => {
      trackWalletConnectInitiated(MixPanelConnectEntryPoint.Header)
    })
    .catch($onError)

  modalStore.openModal(Modal.Connect)
}
</script>

<template>
  <div class="flex items-center gap-1.5">
    <LazyLayoutWalletDetails v-if="sharedWalletStore.isUserConnected" />

    <UButton
      v-else
      class="min-w-28 justify-center"
      v-bind="{
        size: 'xs',
        loading:
          sharedWalletStore.walletConnectStatus ===
          WalletConnectStatus.connecting
      }"
      @click="onWalletConnect"
    >
      {{ $t('common.startHere') }}
    </UButton>

    <LayoutWalletSettings />
  </div>

  <ModalsAccessGate />
  <LazyModalsConnect v-if="modalStore.modals[Modal.Connect]" />
</template>
